import {
  ADD_ALERT_NOTE,
  ADD_ALERT_NOTE_FAIL,
  ADD_ALERT_NOTE_SUCCESS,
  FETCH_ALERT_NOTE_HISTORY,
  FETCH_ALERT_NOTE_HISTORY_FAIL,
  FETCH_ALERT_NOTE_HISTORY_SUCCESS,
  RESET_ALERT_NOTE
} from '../../actions/cm/alertNote';

export const initialState = {
  isLoading: false,
  hasError: false,
  alertNoteHistorylist: [],
  alertNoteHistoryTotal: 0
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case ADD_ALERT_NOTE:
      return {
        ...state,
        isLoading: true
      };
    case ADD_ALERT_NOTE_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case ADD_ALERT_NOTE_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };
    case FETCH_ALERT_NOTE_HISTORY:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_ALERT_NOTE_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        alertNoteHistorylist: payload.list,
        alertNoteHistoryTotal: payload.total
      };
    case FETCH_ALERT_NOTE_HISTORY_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };
    case RESET_ALERT_NOTE:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
